export default __webpack_public_path__ + "static/navigation_b.62b790beefca53066b26f18034f4efdd.png";